<nb-card>
    <nb-card-header class="d-flex pb-0 pe-3"><morva-icons icon="error"></morva-icons><span class="text me-1">خطا</span></nb-card-header>
    <nb-card-body>
      <p class="text">بارگذاری منبع داده با مشکل مواجه شد. نوع داده ورودی آرایه و تودرتو پشتیبانی نمی‌شود.</p>
      <div class="d-flex align-items-center justify-content-center"><button tabindex="-1" (click)="close()">تایید</button></div>
    </nb-card-body>
  </nb-card>
  